import styled, { css } from "styled-components";
import { getCssForMobileView } from "styles/responsive";
import { LinkResolver } from "app/components/link-resolver/link-resolver";
import { CTAButton } from "app/components/shared/cta-button/cta-button-styles";

const GenericPageMobile = css`
  justify-content: flex-start;
  padding: 132px 25px 0;
  text-align: left;
  align-items: flex-start;
`;

export const GenericPage = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
  font-family: ${({ theme }) => theme.secondaryFontFamily};
  color: ${({ theme }) => theme.grey["800"]};
  ${getCssForMobileView(GenericPageMobile)};
`;

export const MiniText = styled.h4`
  margin: 0;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

const TitleMobile = css`
  font-size: 43px;
  line-height: 51px;
  margin-top: 16px;
`;

export const Title = styled.h1<{ colorText?: string }>`
  margin-top: 8px;
  font-family: ${({ theme }) => theme.primaryFontFamily};
  font-style: normal;
  font-weight: bold;
  font-size: 36px;
  line-height: 46px;
  color: ${({ colorText }) => colorText ?? "initial"};
  ${getCssForMobileView(TitleMobile)};
`;

const TextMobile = css`
  font-size: 18px;
  margin-top: 16px;
`;

export const Text = styled.p`
  margin-top: 8px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  ${getCssForMobileView(TextMobile)};
`;

export const Link = styled(LinkResolver)`
  color: ${({ theme }) => theme.blue};
  font-weight: 600;
`;

const ButtonMobile = css`
  width: 100%;
`;

export const Button = styled(CTAButton)`
  justify-content: center;
  color: ${({ theme }) => theme.blue["300"]};
  background-color: ${({ theme }) => theme.white};
  ${getCssForMobileView(ButtonMobile)}
`;
